import { Link } from 'react-router-dom';

const footerLinks = {
  content: [
    { label: '热门电影', path: '/category/movie' },
    { label: '热门剧集', path: '/category/tv' },
    { label: '综艺节目', path: '/category/variety' },
    { label: '纪录片', path: '/category/documentary' },
    { label: '动漫', path: '/category/anime' },
    { label: '少儿', path: '/category/kids' },
  ],
  support: [
    { label: '使用帮助', path: '/about' },
    { label: '常见问题', path: '/about' },
    { label: '意见反馈', path: '/about' },
    { label: '联系我们', path: '/about' },
  ],
  about: [
    { label: '关于我们', path: '/about' },
    { label: '品牌故事', path: '/about' },
    { label: '用户口碑', path: '/about' },
    { label: '隐私政策', path: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-play-circle-fill text-xl text-background-50"></i>
              </div>
              <span className="text-lg font-bold text-foreground-950 font-heading">
                在线观看
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              随时随地畅享高清内容。无需下载，打开即看。海量高清影视、综艺、纪录片任意选择，支持多终端同步，流畅不卡顿。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200 text-foreground-600 hover:text-foreground-950 hover:bg-background-300 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200 text-foreground-600 hover:text-foreground-950 hover:bg-background-300 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200 text-foreground-600 hover:text-foreground-950 hover:bg-background-300 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              <a href="/category/all" className="hover:text-primary-500 transition-colors">精彩内容</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.content.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">帮助支持</h4>
            <ul className="space-y-2.5">
              {footerLinks.support.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              {footerLinks.about.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            &copy; 2026 在线观看 zaixianguankan.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="/about" className="text-xs text-foreground-600 hover:text-foreground-950 transition-colors">隐私政策</a>
            <a href="/about" className="text-xs text-foreground-600 hover:text-foreground-950 transition-colors">服务条款</a>
            <a href="/about" className="text-xs text-foreground-600 hover:text-foreground-950 transition-colors">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}